__webpack_require__.p = "https://wt-res-dev.wt-dc5-dev.dtek.cloud/";